"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsPayProvidersByTrustZonesListCtl = /** @class */ (function (_super) {
    __extends(BrandsPayProvidersByTrustZonesListCtl, _super);
    function BrandsPayProvidersByTrustZonesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_pay_provider_config_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pay_provider_config_id; });
        _this.dk_pay_provider_config_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pay_provider_config_title; });
        _this.dk_trust_zone_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trust_zone_code; });
        _this.dk_trust_zone_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trust_zone_title; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsPayProvidersByTrustZonesListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.LoadData = function (brandId, allTrustZones, trustZoneCode, onDone) {
        var _this = this;
        webAApi_1.ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet.exec({
            brand_id: brandId,
            all_trust_zones: allTrustZones,
            app_trust_zone_code: trustZoneCode
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    pay_provider_config_id: resp.list[i].pay_provider_config_id,
                    pay_provider_config_title: resp.list[i].pay_provider_config_title,
                    trust_zone_code: resp.list[i].trust_zone_code,
                    trust_zone_title: resp.list[i].trust_zone_title,
                    order_number: resp.list[i].order_number,
                    is_locked: resp.list[i].is_locked,
                    description: resp.list[i].description,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandPayProviderToTrustZone.exec({
            data: {
                brand_id: data.brand_id,
                brand_pay_provider_id: data.brand_pay_provider_id,
                app_trust_zone_code: data.app_trust_zone_code,
                order_number: data.order_number,
                is_locked: data.is_locked,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                pay_provider_config_id: data.brand_pay_provider_id,
                pay_provider_config_title: resp.brand_pay_provider_title,
                order_number: data.order_number,
                is_locked: data.is_locked,
                description: data.description,
                trust_zone_code: data.app_trust_zone_code,
                trust_zone_title: resp.app_trust_zone_title,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPayProviderInTrustZone.exec({
                data: {
                    brands_pay_provider_by_trust_zone_id: data.key,
                    is_locked: data.is_locked,
                    order_number: data.order_number,
                    description: data.description
                }
            }, function (resp) {
                _tmp.is_locked = data.is_locked;
                _tmp.order_number = data.order_number;
                _tmp.description = data.description;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandPayProviderFromTrustZone.exec({
                data: {
                    brands_pay_provider_by_trust_zone_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.DoSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandPayProviderInTrustZoneIsLocked.exec({
                data: {
                    brands_pay_provider_by_trust_zone_id: key,
                    is_locked: isLocked
                }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.DoSetOrderNumber = function (key, orderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandPayProviderInTrustZoneOrderNumber.exec({
                data: {
                    brands_pay_provider_by_trust_zone_id: key,
                    order_number: orderNumber
                }
            }, function (resp) {
                _tmp.order_number = orderNumber;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersByTrustZonesListCtl.prototype.DoFillTrustZone = function (brandId, trustZoneCode, onDone) {
        var _this = this;
        //let _tmp = this.getById(key);
        // if (_tmp) {
        webAApi_1.DoFillBrandPayProvidersToTrustZone.exec({
            data: {
                brand_id: brandId,
                app_trust_zone_code: trustZoneCode
            }
        }, function (resp) {
            //_tmp.order_number = orderNumber;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
        //  }
    };
    return BrandsPayProvidersByTrustZonesListCtl;
}(BaseController_1.BaseController));
exports.BrandsPayProvidersByTrustZonesListCtl = BrandsPayProvidersByTrustZonesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsPayProvidersByTrustZonesCtl.ts
// module id = 1061
// module chunks = 0